// eventually this should be a hash string;

import type { AxiosError } from 'axios';

// extract it to a type to allow for easier replacement down the road
export type identifier = number;

export type ServerError = AxiosError<string[]>;

export function isServerError<T>(object: unknown): object is ServerError {
  return Object.prototype.hasOwnProperty.call(object, 'isAxiosError');
}
